/**
 * Format a money amount with its currency symbol (tag matter-economics).
 *
 * Economics responses carry a `currency` (lowercase ISO 4217) alongside every
 * money value; render the two together rather than a bare number. Uses the
 * platform's Intl formatting so the symbol, grouping and decimals match the
 * user's locale. The currency code is always presented uppercase.
 *
 *   formatCurrency(2550, 'usd') // "$2,550.00"
 *   formatCurrency(8000, 'eur') // "€8,000.00"
 */
export function formatCurrency(amount: number, currency = 'usd', locale?: string): string {
  const code = (currency || 'usd').toUpperCase();
  try {
    return new Intl.NumberFormat(locale ?? navigator.language, {
      style: 'currency',
      currency: code,
      currencyDisplay: 'symbol',
    }).format(Number(amount || 0));
  } catch {
    // Unknown/invalid currency code → fall back to "<CODE> 1,234.56".
    return `${code} ${Number(amount || 0).toLocaleString()}`;
  }
}

export default formatCurrency;
